/**
 * Déclenche le téléchargement d'un fichier.
 *
 * L'attribut `download` d'un lien est ignoré par le navigateur quand l'URL est
 * cross-origin : le CV est servi par l'API (portfolio-api), pas par le domaine
 * du front, donc un simple lien ouvrirait le PDF au lieu de l'enregistrer. On
 * récupère le fichier en blob (CORS ouvert sur /storage) puis on télécharge
 * depuis une URL locale. Si le fetch échoue, on retombe sur le lien direct.
 *
 * @param event    événement du clic
 * @param fileUrl  URL du fichier (absolue ou relative au front)
 * @param filename nom de fichier suggéré (par défaut : celui de l'URL)
 */
export let handleDownloadClick = (event, fileUrl, filename = null) => {
	if (event) {
		if (typeof event.persist === "function") event.persist();
		event.preventDefault();
		event.stopPropagation();
	}

	const suggestedName = filename
		|| decodeURIComponent(String(fileUrl).split("?")[0].split("/").pop())
		|| "document.pdf";

	const triggerDownload = (href, isBlob) => {
		const element = document.createElement("a");
		element.href = href;
		element.setAttribute("download", suggestedName);
		element.style.display = "none";

		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);

		if (isBlob) setTimeout(() => URL.revokeObjectURL(href), 10000);
	};

	fetch(fileUrl)
		.then((response) => {
			if (!response.ok) throw new Error(`HTTP ${response.status}`);
			return response.blob();
		})
		.then((blob) => triggerDownload(URL.createObjectURL(blob), true))
		.catch(() => triggerDownload(fileUrl, false));
};
